import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailGeneral = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M23.89,5.83a.18.18,0,0,0-.2,0l-9.75,9.75a2.72,2.72,0,0,1-1.94.8,2.79,2.79,0,0,1-1.95-.8L.31,5.87a.18.18,0,0,0-.2,0A.18.18,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.18.18,0,0,0,23.89,5.83Z",
		style: { fill: "currentColor" }
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.11,14.56a1.27,1.27,0,0,0,1.77,0l9.69-9.69a.5.5,0,0,0,.12-.51C22.58,4,22.27,4,22,4H2c-.28,0-.58,0-.69.36a.5.5,0,0,0,.12.51Z",
		style: { fill: "currentColor" }
	})] })
});
export { SvgEmailGeneral as ReactComponent };
